export enum MediaQueries {
  S_MOBILE = 320,
  M_MOBILE = 415,
  S_TABLET = 768,
  M_TABLET = 834,
  S_DESKTOP = 1200,
  M_DESKTOP = 1600,
}
